function popupClose() {
    $('.js-popup').stop(0).fadeOut(200);
}

$(document).on('click', function(e) {
    var $popup = $('.js-popup');

    if (!$popup.is(e.target) && $popup.has(e.target).length === 0) {
        $popup.stop(0).fadeOut(200);
        $('.js-popup-action').removeClass('is-active');
    }
});

$(document).on('click', '.js-popup-action[data-action="click"]', function() {
    var $this = $(this);
    var closestContainer = $this.closest('.js-popup-container');
    var childPopup = closestContainer.find('.js-popup');

    $('.js-popup').not(childPopup).fadeOut(200);
    $('.js-popup-action').not($this).removeClass('is-active');

    $this.toggleClass('is-active');
    childPopup.stop(0).fadeToggle(200);

    return false;
});

$(window)
    .scroll(function() {
        popupClose();
    })
    .smartResize(function() {
        popupClose();
    });